import { type FC } from "react";
import Lock from "@mui/icons-material/Lock";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";
import { SignOutButton } from "../components/sign-out-button";

export const AccessDeniedPage: FC = () => (
  <InfoPageLayout>
    <InfoPage
      title="Нет доступа к EkoCrop"
      message="Обратитесь к администратору, чтобы получить доступ"
      illustration={<InfoPageIllustration icon={Lock} />}
      actions={
        <>
          <SignOutButton />
          <SignInButton />
        </>
      }
    />
  </InfoPageLayout>
);
